const WIZARD_RETURN_TO_KEY = 'agd:wizardReturnTo';

export function getWizardReturnTo(state: unknown): string | undefined {
  if (typeof state !== 'object' || state === null || !('returnTo' in state)) {
    return undefined;
  }
  const returnTo = (state as { returnTo?: unknown }).returnTo;
  return typeof returnTo === 'string' && returnTo.startsWith('/') ? returnTo : undefined;
}

/** Remember the screen the user came from when entering the create-case-request wizard. */
export function persistWizardReturnTo(state: unknown): void {
  const returnTo = getWizardReturnTo(state);
  if (returnTo) {
    sessionStorage.setItem(WIZARD_RETURN_TO_KEY, returnTo);
  }
}

/** Read and clear the stored wizard return path (used when cancelling). */
export function consumeWizardReturnTo(): string | undefined {
  const returnTo = sessionStorage.getItem(WIZARD_RETURN_TO_KEY) ?? undefined;
  sessionStorage.removeItem(WIZARD_RETURN_TO_KEY);
  return returnTo;
}
